module.exports = "../../static/img/twitter-logo.089756c.jpeg";


//////////////////
// WEBPACK FOOTER
// ./static/images/twitter-logo.jpeg
// module id = BPUm
// module chunks = 2